import { CR_API_ENDPOINTS } from '../constants';
import { BuildingHeight } from '../types';
import { apiService } from './api.service';

class BuildingHeightsService {
  async getAllBuildingHeights(): Promise<BuildingHeight[]> {
    return apiService.get<BuildingHeight[]>(CR_API_ENDPOINTS.BUILDING_HEIGHTS);
  }

  async getBuildingHeightById(id: string): Promise<BuildingHeight> {
    return apiService.get<BuildingHeight>(`${CR_API_ENDPOINTS.BUILDING_HEIGHTS}/${id}`);
  }

  async createBuildingHeight(buildingHeightData: {
    value: string;
  }): Promise<BuildingHeight> {
    try {
      return await apiService.post<BuildingHeight>(CR_API_ENDPOINTS.BUILDING_HEIGHTS, buildingHeightData);
    } catch (error) {
      throw new Error(`Failed to create building height: ${error}`);
    }
  }
}

export const buildingHeightsService = new BuildingHeightsService();